import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["Building tomorrow's practice the night before — unpaid", 'Staring at a blank page at 3:30 with no idea what to run today', 'Half your room has never wrestled. The other half is bored', 'Splitting the room into two practices and running neither one well', 'Running out of drills and warm-up games by week three', 'Your first year as a coach, and you never wrestled', 'Planning with Word docs, paper and an overflowing inbox', 'Burning mat time deciding what to do with it'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-plum" data-id="element-168" data-mp="1bpkta8sfv71f">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-169" data-mp="1brnvrsas2sn1">
        <div className="text-center" data-id="element-170" data-mp="17pkg0rh2t1vy">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-171" data-mp="17qluz717q8iy">
            The part nobody pays you for
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-172" data-mp="323bo3mjrbdpa">
            If you coach wrestling, you know at least{' '}
            <span className="text-coral-soft" data-id="element-173" data-mp="3l9hl7r8xx8rl">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-174" data-mp="37a848pcwuamk">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-2xl border border-plum-line bg-plum-card px-4 py-4 text-sm text-white/85" data-id="element-175" data-mp="3bc35jtuuco0c">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/20" data-id="element-176" data-mp="7si8v5pnjtws">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-177" data-mp="3q5gffvgy9kzx" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl sm:text-3xl text-gold leading-tight" data-id="element-178" data-mp="qjrl3mqt4ws2">
          How many more nights do you want to spend building tomorrow&apos;s practice?
        </p>
      </div>
    </section>;
}